'use client'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { Perils } from '@/components/Perils/Perils'
import { useMissingPerils } from '@/components/Perils/useMissingPerils'
import { useProductData, useSelectedProductVariant } from '@/components/ProductData/ProductDataProvider'
import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { Badge } from 'ui/src/components/Badge/Badge'
import { sprinkles } from 'ui/src/theme/sprinkles.css'

type PerilsBlockProps = SbBaseBlockProps<{
  heading?: string
  hideDisabledPerils?: boolean
}>

export const PerilsBlock = ({ blok, nested }: PerilsBlockProps) => {
  const { variants } = useProductData()
  const selectedProductVariant = useSelectedProductVariant()
  const productVariant = selectedProductVariant ?? variants.at(0)
  const perils = productVariant ? productVariant.perils : []
  const missingPerils = useMissingPerils(perils)

  return (
    <GridLayout.Root {...storyblokEditable(blok)} nested={nested}>
      <GridLayout.Content width="1">
        {blok.heading && <Badge className={sprinkles({ marginBottom: 'md' })}>{blok.heading}</Badge>}
        <Perils items={perils} missingItems={blok.hideDisabledPerils ? [] : missingPerils} />
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
